module.exports = __webpack_public_path__ + "static/img-misty-mint-db6713f364620e2c967561b133e56386.jpg";